import { Component } from '@angular/core';
import { NgIf, AsyncPipe } from "@angular/common";
import { RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { AuthenticationService } from "../../../authentications/authentication.service";
import { Film, Rss, ListCheck, ListRestart, NotebookPen, CalendarRange, Mail, LucideAngularModule } from "lucide-angular";
import { MatDialog } from '@angular/material/dialog';
import { ContactComponent } from '../../../shared/components/contact/contact.component';
import { UserType } from '../../../shared/dtos/user-dto';

@Component({
  selector: 'fspro-user-features-box',
  imports: [
    NgIf,
    AsyncPipe,
    RouterLink,
    TranslateModule,
    LucideAngularModule
  ],
  templateUrl: './user-features-box.component.html',
  styleUrl: './user-features-box.component.scss'
})
export class UserFeaturesBoxComponent {

  readonly Film = Film;
  readonly Rss = Rss;
  readonly ListCheck = ListCheck;
  readonly ListRestart = ListRestart;
  readonly NotebookPen = NotebookPen;
  readonly CalendarRange = CalendarRange;
  readonly Mail = Mail;

  protected readonly UserType = UserType;

  constructor(public readonly authenticationService: AuthenticationService, private readonly dialog: MatDialog) {
  }

  onOpenContact() {
    this.dialog.open(ContactComponent, {
      width: '480px',
      panelClass: ['send-message-dialog-panel-class', 'large'],
      disableClose: true
    });
  }
}
